'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactsMaxLimitContainer = function ContactsMaxLimitContainer(props) {
  return _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/common/info-box/AuthContactLimitBox');
    },
    publicComponentLoader: function publicComponentLoader() {
      return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/common/info-box/PublicContactLimitBox');
    },
    authedComponentProps: props,
    publicComponentProps: props
  });
};

exports.default = ContactsMaxLimitContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/info-box/ContactsMaxLimitContainer.js
// module id = 683
// module chunks = 3 4